module.exports = __webpack_public_path__ + "img/pet_salute_plus.77629ef8.jpg";